module.exports = __webpack_public_path__ + "img/unis_cite.7ae49a98.jpg";